import { createSelector } from 'reselect';
import { RootState } from '@root/rootReducer';

export const getSelectedSeries = (state: RootState) =>
  state.analysis.selectedAnalysis?.seriesId;


const selectedPanelConfig = (state: RootState) =>
  state.analysis.uiConfig.layoutState.selectedPanelConfig;

export const selectedPanelType = (state: RootState) =>
  state.analysis.uiConfig.layoutState.selectedPanelConfig?.panelId

export const selectCurrentPanelTool = createSelector(
  [selectedPanelType, (state: RootState) => state.analysis.toolStatesV2],
  (panelId, toolStatev2) => {
    if (!panelId) return undefined;
    return toolStatev2.panels[panelId];
  }
);

export const currentGlobalToolStates = (state: RootState) => state.analysis.toolStatesV2.global;

export const selectCurrentToolState = createSelector(
  [selectedPanelConfig, (state: RootState) => state.analysis.toolStates],
  (selectedPanelConfig, toolStates) => {
    const panelId = selectedPanelConfig?.panelId || 'EmptyPanel';
    return toolStates[panelId];
  },
);

export const selectCurrentPanelState = createSelector(
  [selectedPanelConfig, (state: RootState) => state.analysis.panelStates],
  (selectedPanelConfig, panelStates) => {
    const panelId = selectedPanelConfig?.componentKey || 'Empty';
    return panelStates[panelId];
  },
);

export const selectSelectedTool = createSelector(
  [selectCurrentToolState],
  (toolState) => toolState?.selectedTool,
);
export const selectExclusiveTool = createSelector(
  [selectCurrentToolState],
  (toolState) => {
    return toolState?.exclusiveTool;
  },
);
export const selectActivatedTool = createSelector(
  [selectCurrentToolState],
  (toolState) => toolState?.activatedTools,
);
// export const selectRecentlyUsedTool = createSelector(
//   [selectCurrentToolState],
//   (toolState) => toolState?.recentlyUsedTool || {},
// );
export const selectedAnalysisSeriesId = (state: RootState) => state.analysis.selectedAnalysis?.seriesId;
// const selectedAnalysisType =
export const getSelectedAnalysisDefault = createSelector(
  [(state:RootState)=>state.analysis.selectedAnalysis?.analysisType ?? 'empty',
  (state:RootState)=>state.analysis.analysisDefaults],
  // [selectedAnalysisType],
  (analysisType,analysisDefaults)=> analysisDefaults[analysisType]
  // {
  //   if(Object.hasOwn(analysisDefaults,analysisType)){
  //     return analysisDefaults[analysisType];
  //   }
  //   return {
  //     windowLevel:defaultWindowCenter,
  //     windowWidth:defaultWindowWidth
  //   } as AnalysisDefault;
  // }
)
// const getSelectedSeriesFirstImageInfo = createSelector(
//   [getSelectedSeriesImages],
//   (images) => {
//     if (!images) return null;
//     return images[0];
//   },
// );



// export const getInitialPanelStates = createSelector(
//   [getSelectedSeries,
//     getSeriesSliceThickness, getSeriesWindowWidth, getSeriesWindowLevel],
//   (seriesUid, sliceThickness, windowWidth, windowLevel): Partial<PanelStates> => {
//     const DICOMPanelState: PanelState = {
//       thicknessMethod: 'MIP',
//       thickness: sliceThickness,
//       windowWidth: windowWidth,
//       windowLevel: windowLevel,
//       zoom: 1.0,
//       // synchronizingTarget: null,
//     };
//     const VRPanelState : PanelState ={
//       windowWidth: windowWidth,
//       windowLevel: windowLevel,
//     }
//     return {
//       Axial: DICOMPanelState,
//       Coronal: DICOMPanelState,
//       Sagittal: DICOMPanelState,
//       VR: VRPanelState
//     };
//   },
// );

// export const getCornerstoneVolumeMetaInfo = createSelector(
//   [getSelectedSeriesImage],(imageTag)=>{
//     return {
//       BitsAllocated : imageTag?.bitsAllocated ?? 16,
//       BitsStored: imageTag?.bitsStored ?? 16,
//       SamplesPerPixel: imageTag?.samplesPerPixel ?? 1,
//       HighBit : imageTag?.highBit ?? 15,
//       PhotometricInterpretation: imageTag?.photometricInterpretation ?? 'MONOCHROME2',
//       PixelRepresentation: imageTag?.pixelRepresentation ?? 1,
//       Modality: imageTag?.modality ?? 'CT',
//       ImageOrientationPatient: imageTag?.imageOrientationPatient.split('\\').map(val=>Number(val)),
//       PixelSpacing: imageTag?.pixelSpacing.split('\\').map(val=>Number(val)) ?? [1,1],
//       Columns:imageTag?.columns ?? 512,
//       Rows:imageTag?.rows ?? 512,
//       FrameOfReferenceUID: '',
//       voiLut: [],
//       VOILUTFunction: '',
//     }

//   }
// )
// 다른 파생 데이터 셀렉터들...
